"use client";

import Image from "next/image";
import ProtectedImage from "./ProtectedImage";

const PALETTE = [
  "#E8A0BF",
  "#7BB5CF",
  "#F0D58C",
  "#E8A672",
  "#A8D5BA",
  "#C4A8D5",
  "#D5A8A8",
  "#A8C4D5",
];

function isRealImage(src) {
  return (
    src &&
    (src.startsWith("http") ||
      src.startsWith("/artworks") ||
      src.startsWith("/api/image-proxy")) &&
    !src.includes("placeholder")
  );
}

export default function ImagePlaceholder({
  name,
  image,
  artworkId,
  className = "",
  aspectRatio = "1/1",
  priority = false,
  sizes,
  responsive = true,
}) {
  if (isRealImage(image)) {
    // 本地圖片直接用，Supabase URL 走 proxy 隱藏原始路徑
    const isSupabaseUrl = image && image.includes("supabase.co");
    const imgSrc =
      artworkId && isSupabaseUrl ? `/api/image-proxy?id=${artworkId}` : image;
    return (
      <div
        className={`relative overflow-hidden ${className}`}
        style={{ aspectRatio, borderRadius: "var(--radius-md)" }}
      >
        <ProtectedImage
          src={imgSrc}
          alt={name || ""}
          priority={priority}
          sizes={sizes}
          responsive={responsive}
          className="w-full h-full object-contain"
          style={{ width: "100%", height: "100%", backgroundColor: "#ffffff" }}
        />
      </div>
    );
  }

  const colorIndex = name
    ? name.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0) %
      PALETTE.length
    : 0;
  const bg = PALETTE[colorIndex];

  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{
        backgroundColor: bg,
        aspectRatio,
        borderRadius: "var(--radius-md)",
      }}
    >
      <span
        className="text-center px-3 leading-tight font-medium"
        style={{
          color: "rgba(255,255,255,0.85)",
          fontFamily: "var(--font-heading)",
          fontSize: "clamp(0.75rem, 3vw, 1.125rem)",
        }}
      >
        {name}
      </span>
    </div>
  );
}
